import React, { useContext, useEffect, useState } from 'react'
import * as gruzovikiApi from '../../utils/api.js'
// import { citiesIds } from "../../utils/services.js";
import { getCityId } from '../../utils/api.js'
import cls from './FilterPopupNew.module.scss'

const MAX_RADIUS_KM = 500

function FilterPopupNew() {
    const token = localStorage.getItem('token')
    const tg = window.Telegram?.WebApp
    tg.expand()

    const [userId, setUserId] = useState(null)
    const [userCity, setUserCity] = useState('')

    useEffect(() => {
        let user_id
        // Если доступен tg.initDataUnsafe
        if (tg?.initDataUnsafe?.user) {
            user_id = tg.initDataUnsafe.user.id
        } else {
            // Если нужно извлечь из URL
            const params = new URLSearchParams(window.location.search)
            const idFromUrl = Number(params.get('userId'))
            user_id = idFromUrl
        }

        setUserId(user_id)

        gruzovikiApi
            .getUserType(user_id, token)
            .then((userType) => {
                const excludedUserIds = [837143843, 5267329136, 425169377]
                if (
                    user_id &&
                    userType === 2 &&
                    !excludedUserIds.includes(user_id)
                ) {
                    console.log(user_id)
                    // Переадресация
                    // window.location.href = 'https://cargo.gruz.app';
                }
                // Если userType = 1, ничего не делаем и продолжаем выполнение
            })
            .catch((err) => {
                console.error('Ошибка получения типа пользователя:', err)
            })
    }, [])

    console.log(userId)

    let todayDate = new Date()
    let tomorrowDate = new Date()
    tomorrowDate.setDate(todayDate.getDate() + 1)
    let afterTomorrowDate = new Date()
    afterTomorrowDate.setDate(todayDate.getDate() + 2)
    // let yesterdayDate = new Date()
    // yesterdayDate.setDate(todayDate.getDate() - 1)

    let searchType = 'city'
    let type_city = 'city'
    let type_intercity = 'intercity'

    const opened = true
    const [filtersArray, setFiltersArray] = useState({
        searchType: searchType,
        cities: [],
        dates: [todayDate, tomorrowDate],
        dateChoose: 'tomorrow',
        radiusA: 0,
        radiusB: 0,
        anywhereA: false,
        anywhereB: false,
        useMyCityA: false,
        useMyCityB: false,
        findReturn: false,
    })

    const [citiesArray, setCitiesArray] = useState([
        {
            cityId: 1,
            name: '',
            error: false,
        },
        {
            cityId: 2,
            name: '',
            error: false,
        },
    ])
    const [filteredCities, setFilteredCities] = useState([]) // Фильтрованные города
    const [showDropdown, setShowDropdown] = useState(0) // Показывать ли выпадающий список

    useEffect(() => {
        gruzovikiApi
            .getUserFilters(userId, token)
            .then((data) => {
                if (data) {
                    let fromDate
                    let toDate
                    switch (data.dateChoose) {
                        case 'today':
                            fromDate = todayDate
                            toDate = todayDate
                            break
                        case 'tomorrow':
                            fromDate = todayDate
                            toDate = tomorrowDate
                            break
                        case 'next':
                            fromDate = todayDate
                            toDate = afterTomorrowDate
                            break
                        case 'from-today':
                            fromDate = todayDate
                            toDate = null
                            break
                        case 'from-tomorrow':
                            fromDate = tomorrowDate
                            toDate = null
                            break
                        default: // Этот блок выполняется, если ни одно условие не совпало
                            fromDate = todayDate
                            toDate = tomorrowDate
                            break
                    }

                    // Если данные есть, устанавливаем их в filtersArray
                    setCitiesArray((prev) => [
                        { cityId: 1, name: data.from_city || '', error: false },
                        { cityId: 2, name: data.to_city || '', error: false },
                    ])
                    setFiltersArray((prev) => ({
                        ...prev,
                        searchType: data.searchType || 'intercity',
                        radiusA: data.radius_from_city || 0,
                        radiusB: data.radius_to_city || 0,
                        anywhereA: data.anywhereA || false,
                        anywhereB: data.anywhereB || false,
                        useMyCityA: data.useMyCityA || false,
                        useMyCityB: data.useMyCityB || false,
                        findReturn: data.findReturn || false,
                        dates: [fromDate, toDate],
                        dateChoose: data.dateChoose || 'tomorrow',
                        orderTypes: data.orderTypes || ['DIRECT'],
                    }))
                }
            })
            .catch((err) => {
                console.error('Ошибка получения фильтров:', err)
            })

        gruzovikiApi
            .getUserCity(userId, token)
            .then((data) => {
                if (data) {
                    setUserCity(data)
                }
            })
            .catch((err) => {
                console.error('Ошибка получения фильтров:', err)
            })
    }, [userId])

    const handleInputRadiusChange = (e) => {
        const { value } = e.target
        if (value >= 0 && value <= MAX_RADIUS_KM) handleInputChange(e)
    }

    const handleInputRadiusClear = () => {
        setFiltersArray((prevInputs) => ({ ...prevInputs, radiusA: '' }))
    }

    const handleInputChange = (e) => {
        const { name, value, type, checked, id } = e.target
        if (type === 'checkbox') {
            setFiltersArray((prevInputs) => {
                // const updatedVehicleType = checked
                // ? [...prevInputs.vehicleType, value]
                // : prevInputs.vehicleType.filter((type) => type !== value);
                // return { ...prevInputs, vehicleType: updatedVehicleType };
                return { ...prevInputs }
            })
        } else {
            setFiltersArray((prevInputs) => {
                let updatedValue
                switch (type) {
                    case 'number':
                        updatedValue = value ? Number(value) : 0
                        break
                    case 'date':
                        updatedValue = value ? new Date(value) : 0
                        break
                    default:
                        updatedValue = value || 0
                        break
                }

                if (id === 'from') {
                    // Устанавливаем значение в нулевой индекс массива
                    return {
                        ...prevInputs,
                        [name]: [
                            updatedValue,
                            ...(prevInputs[name].slice(1) || [0, 0]),
                        ],
                    }
                } else if (id === 'to') {
                    // Устанавливаем значение в первый индекс массива
                    return {
                        ...prevInputs,
                        [name]: [
                            prevInputs[name][0] !== undefined
                                ? prevInputs[name][0]
                                : 0,
                            updatedValue,
                            ...(prevInputs[name].slice(2) || [0, 0]),
                        ],
                    }
                } else {
                    // Для других случаев
                    return { ...prevInputs, [name]: updatedValue }
                }
            })
        }
    }

    const handleReset = () => {
        setCitiesArray([
            {
                cityId: 1,
                name: '',
            },
            {
                cityId: 2,
                name: '',
            },
        ])
        setFiltersArray({
            searchType: 'city',
            cities: [],
            dates: [todayDate, tomorrowDate],
            dateChoose: 'tomorrow',
            radiusA: 0,
            radiusB: 0,
        })
    }

    console.log(citiesArray)

    const handleSubmit = async () => {
        const activeIdx = filtersArray.searchType === 'city' ? [0] : [0, 1]

        const results = await Promise.all(
            activeIdx.map(async (idx) => {
                const city = citiesArray[idx]
                const anywhere =
                    idx === 0 ? filtersArray.anywhereA : filtersArray.anywhereB
                if (anywhere)
                    return { idx, ok: true, trimmedName: '', cityId: null }

                const trimmedName = city.name.trim()
                if (!trimmedName)
                    return { idx, ok: false, trimmedName, cityId: 0 }

                const cityId = await getCityId(trimmedName)
                return { idx, ok: cityId !== 0, trimmedName, cityId }
            })
        )

        const updatedCitiesArray = citiesArray.map((c, idx) => {
            const res = results.find((r) => r.idx === idx)
            return res
                ? { ...c, name: res.trimmedName || c.name, error: !res.ok }
                : { ...c, error: false }
        })
        setCitiesArray(updatedCitiesArray)

        if (!results.every((r) => r.ok)) return

        // ⭐ для city отправляем [A, A]; для intercity — [A, B]
        const first = updatedCitiesArray[0].name
        const submitCitiesArray =
            filtersArray.searchType === 'city'
                ? [first, first]
                : [
                      updatedCitiesArray[0].name,
                      updatedCitiesArray[1].name,
                  ].filter(Boolean)

        const payload = { ...filtersArray, cities: submitCitiesArray }
        console.log('payload', payload)
        setFiltersArray((prev) => ({ ...prev, cities: submitCitiesArray }))

        gruzovikiApi
            .searchOrders(payload, userId)
            .then((res) => console.log(res))
            .catch((err) => console.error(err))

        setTimeout(() => tg.close(), 500)
    }

    const handleDateCheckboxClick = (id) => {
        let fromDate
        let toDate
        switch (id) {
            case 'today':
                fromDate = todayDate
                toDate = todayDate
                break
            case 'tomorrow':
                fromDate = todayDate
                toDate = tomorrowDate
                break
            case 'next':
                fromDate = todayDate
                toDate = afterTomorrowDate
                break
            case 'from-today':
                fromDate = todayDate
                toDate = null
                break
            case 'from-tomorrow':
                fromDate = tomorrowDate
                toDate = null
                break
        }
        setFiltersArray((prevInputs) => ({
            ...prevInputs,
            dates: [fromDate, toDate],
            dateChoose: id,
        }))
    }

    const handleTypeCheckboxClick = (type) => {
        setFiltersArray((prevInputs) => ({ ...prevInputs, searchType: type }))
    }

    const handleCityNameChange = (e, cityId) => {
        const newName = e.target.value

        let anywherename
        let useMyCityName

        if (cityId === 1) {
            anywherename = 'anywhereA'
            useMyCityName = 'useMyCityA'
        } else if (cityId === 2) {
            anywherename = 'anywhereB'
            useMyCityName = 'useMyCityB'
        }

        // Обновляем только тот объект, у которого cityId совпадает
        const updatedCitiesArray = citiesArray.map((city) =>
            city.cityId === cityId ? { ...city, name: newName } : city
        )
        setCitiesArray(updatedCitiesArray)

        // Фильтрация городов
        if (newName.trim() === '') {
            setFilteredCities([])
            setShowDropdown(0)
        } else {
            gruzovikiApi
                .filterCities(newName)
                .then((data) => {
                    setFilteredCities(data)
                    setShowDropdown(cityId)
                })
                .catch((err) => {
                    console.error('Ошибка при фильтрации городов:', err)
                })
        }

        let submitCitiesArray = updatedCitiesArray
            .filter((city) => city.name !== '')
            .map((city) => city.name)
        setFiltersArray((prevInputs) => {
            return {
                ...prevInputs,
                cities: submitCitiesArray,
                [anywherename]: false,
                [useMyCityName]: false,
            }
        })
    }

    const handleCitySelect = (newCity, cityId) => {
        // Обновляем только тот объект, у которого cityId совпадает
        const updatedCitiesArray = citiesArray.map((city) =>
            city.cityId === cityId ? { ...city, name: newCity } : city
        )
        setCitiesArray(updatedCitiesArray)

        // Закрываем выпадающий список
        setShowDropdown(0)
        setFilteredCities([])
    }

    const handleSwapAddresses = () => {
        // Меняем местами названия городов
        setCitiesArray((prev) => {
            const newArray = [...prev]
            ;[newArray[0].name, newArray[1].name] = [
                newArray[1].name,
                newArray[0].name,
            ]
            return newArray
        })

        // Сбрасываем ошибки для обоих полей
        setCitiesArray((prev) =>
            prev.map((city) => ({ ...city, error: false }))
        )

        // Меняем местами связанные состояния в filtersArray
        setFiltersArray((prev) => ({
            ...prev,
            // Меняем местами радиусы
            radiusA: prev.radiusB,
            radiusB: prev.radiusA,
            // Меняем местами флаги "Откуда угодно"
            anywhereA: prev.anywhereB,
            anywhereB: prev.anywhereA,
            // Меняем местами флаги "Мой город"
            useMyCityA: prev.useMyCityB,
            useMyCityB: prev.useMyCityA,
            // Обновляем массив cities для совместимости
            cities:
                prev.cities.length >= 2
                    ? [prev.cities[1], prev.cities[0]]
                    : prev.cities,
        }))

        // Закрываем выпадающий список, если он открыт
        setShowDropdown(0)
        setFilteredCities([])
    }

    // Обработчик изменения состояния чекбокса Мой город
    const handleCheckboxMyCityChange = (e, cityId) => {
        let newName
        let anywherename
        let useMyCityName
        if (e.target.checked) {
            newName = userCity
        } else {
            newName = ''
        }

        if (cityId === 1 && e.target.checked === true) {
            anywherename = 'anywhereA'
        } else if (cityId === 2 && e.target.checked === true) {
            anywherename = 'anywhereB'
        }

        if (cityId === 1) {
            useMyCityName = 'useMyCityA'
        } else if (cityId === 2) {
            useMyCityName = 'useMyCityB'
        }

        // Обновляем только тот объект, у которого cityId совпадает
        const updatedCitiesArray = citiesArray.map((city) =>
            city.cityId === cityId
                ? { ...city, name: newName, error: false }
                : city
        )
        setCitiesArray(updatedCitiesArray)

        setFiltersArray((prevInputs) => {
            return {
                ...prevInputs,
                [anywherename]: false,
                [useMyCityName]: e.target.checked,
            }
        })
    }

    // Обработчик изменения состояния откуда-куда угодно
    const handleCheckboxAnywhereChange = (e) => {
        const { name, checked } = e.target

        let checkCityId
        let useMyCityName
        if (name === 'anywhereA') {
            checkCityId = 1
        } else {
            checkCityId = 2
        }

        if (checkCityId === 1 && e.target.checked === true) {
            useMyCityName = 'useMyCityA'
        } else if (checkCityId === 2 && e.target.checked === true) {
            useMyCityName = 'useMyCityB'
        }

        const updatedCitiesArray = citiesArray.map((city) =>
            city.cityId === checkCityId
                ? { ...city, name: '', error: false }
                : city
        )
        setCitiesArray(updatedCitiesArray)

        setFiltersArray((prevInputs) => {
            return {
                ...prevInputs,
                [name]: e.target.checked,
                [useMyCityName]: false,
            }
        })

        console.log(name, checked)
    }

    // Обработчик поиска обратки
    const handleCheckboxFindReturnChange = (e) => {
        const { name, checked } = e.target

        setFiltersArray((prevInputs) => {
            return { ...prevInputs, [name]: e.target.checked }
        })

        console.log(name, checked)
    }

    // Обработчик догруза
    const handleCheckboxReloadChange = (e) => {
        const { name, checked } = e.target

        setFiltersArray((prevInputs) => {
            return {
                ...prevInputs,
                [name]: e.target.checked ? ['ADDITIONAL_LOAD'] : ['DIRECT'],
            }
        })

        console.log(name, checked)
    }

    const handleClearCityName = (e, cityId) => {
        const newName = ''

        let useMyCityName

        if (cityId === 1) {
            useMyCityName = 'useMyCityA'
        } else if (cityId === 2) {
            useMyCityName = 'useMyCityB'
        }

        // Обновляем только тот объект, у которого cityId совпадает
        const updatedCitiesArray = citiesArray.map((city) =>
            city.cityId === cityId ? { ...city, name: newName } : city
        )
        setCitiesArray(updatedCitiesArray)

        setShowDropdown(0)
        setFilteredCities([])

        setFiltersArray((prevInputs) => {
            return { ...prevInputs, [useMyCityName]: false }
        })
    }

    // -----------------------------------------------------------

    const tabs = [
        { type: 'city', icon: '🏙', label: 'Город' },
        { type: 'intercity', icon: '🛣', label: 'Межгород' },
    ]

    const dates = [
        {
            type: 'next',
            text: 'Сегодня - завтра - послезавтра',
        },
        {
            type: 'today',
            text: 'Сегодня',
        },
        {
            type: 'tomorrow',
            text: 'Сегодня - завтра',
        },
        {
            type: 'from-today',
            text: 'С этого дня',
        },
        {
            type: 'from-tomorrow',
            text: 'Начиная с завтра',
        },
    ]

    const isCity = filtersArray.searchType === 'city'
    const isReload = filtersArray?.orderTypes?.[0] === 'ADDITIONAL_LOAD'

    return (
        <div className={cls.page}>
            <div className={cls.content}>
                <h1 className={cls.pageTitle}>
                    {isCity ? 'Фильтр по городу' : 'Фильтр по межгороду'}
                </h1>

                <div className={cls.tabsWrapper}>
                    <div className={cls.tabs}>
                        {tabs.map((t) => (
                            <button
                                key={t.type}
                                className={`${cls.tab} ${filtersArray.searchType === t.type ? cls.active : ''}`}
                                onClick={() => handleTypeCheckboxClick(t.type)}
                            >
                                <span style={{ fontSize: 16 }}>{t.icon}</span>
                                {t.label}
                            </button>
                        ))}
                    </div>
                </div>

                <div className={cls.section}>
                    <div className={cls.sectionTitle}>
                        {isCity ? 'Город' : 'Маршрут'}
                    </div>
                    <div
                        className={`${cls.addressRow} ${citiesArray[0].error ? [cls.error] : ''}`}
                    >
                        <div className={cls.addressPin}>
                            {isCity ? '📍' : 'A'}
                        </div>
                        <div className={cls.addressInputWrapper}>
                            {!isCity && (
                                <p
                                    className={`${cls.addressInputLabel} ${citiesArray[0].name ? [cls.withValue] : ''}`}
                                >
                                    Откуда
                                </p>
                            )}
                            <input
                                type="text"
                                placeholder={`${isCity ? 'Введите город' : ''}`}
                                className={`${cls.addressInput} ${!isCity && citiesArray[0].name ? [cls.withValue] : ''}`}
                                name="startCity"
                                id="adress-a"
                                value={citiesArray[0].name}
                                onChange={(e) => handleCityNameChange(e, 1)}
                                onFocus={() => setShowDropdown(1)} // Показываем список при фокусе
                                onBlur={() =>
                                    setTimeout(() => setShowDropdown(0), 200)
                                } // Скрываем список с задержкой
                            />
                        </div>

                        <button
                            className={cls.clearButton}
                            onClick={(e) => handleClearCityName(e, 1)}
                        >
                            ✕
                        </button>

                        {showDropdown === 1 && filteredCities.length > 0 && (
                            <ul className={cls.dropdown}>
                                {filteredCities.map((city) => (
                                    <li
                                        key={city}
                                        className={cls.dropdownItem}
                                        onClick={() =>
                                            handleCitySelect(city, 1)
                                        }
                                    >
                                        {city}
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>

                    {!isCity && !filtersArray.anywhereB && (
                        <div className={cls.swapButtonWrapper}>
                            <button
                                className={cls.swapButton}
                                onClick={handleSwapAddresses}
                            >
                                ⇅
                            </button>
                        </div>
                    )}

                    {!isCity && !filtersArray.anywhereB && (
                        <div
                            className={`${cls.addressRow} ${citiesArray[1].error ? [cls.error] : ''}`}
                        >
                            <div className={`${cls.addressPin} ${cls.red}`}>
                                B
                            </div>

                            <div className={cls.addressInputWrapper}>
                                <p
                                    className={`${cls.addressInputLabel} ${citiesArray[1].name ? [cls.withValue] : ''}`}
                                >
                                    Куда
                                </p>
                                <input
                                    type="text"
                                    className={`${cls.addressInput} ${!isCity && citiesArray[1].name ? [cls.withValue] : ''}`}
                                    name="endCity"
                                    id="adress-b"
                                    value={citiesArray[1].name}
                                    onChange={(e) => handleCityNameChange(e, 2)}
                                    onFocus={() => setShowDropdown(2)} // Показываем список при фокусе
                                    onBlur={() =>
                                        setTimeout(
                                            () => setShowDropdown(0),
                                            100
                                        )
                                    } // Скрываем список с задержкой
                                />
                            </div>

                            <button
                                className={cls.clearButton}
                                onClick={(e) => handleClearCityName(e, 2)}
                            >
                                ✕
                            </button>

                            {showDropdown === 2 &&
                                filteredCities.length > 0 && (
                                    <ul className={cls.dropdown}>
                                        {filteredCities.map((city) => (
                                            <li
                                                key={city}
                                                className={cls.dropdownItem}
                                                onClick={() =>
                                                    handleCitySelect(city, 2)
                                                }
                                            >
                                                {city}
                                            </li>
                                        ))}
                                    </ul>
                                )}
                        </div>
                    )}

                    <div className={cls.divider} />

                    <div className={cls.radiusRow}>
                        <span className={cls.radiusLabel}>Радиус поиска</span>
                        <input
                            type="number"
                            min="0"
                            name="radiusA"
                            id="radius-a"
                            pattern="[0-9]*"
                            value={
                                filtersArray.radiusA === 0
                                    ? ''
                                    : filtersArray.radiusA
                            }
                            className={cls.radiusInput}
                            onChange={handleInputRadiusChange}
                            onKeyDown={(e) => {
                                // Блокируем ввод символов e, E, +, -
                                if (
                                    e.key === 'e' ||
                                    e.key === 'E' ||
                                    e.key === '+' ||
                                    e.key === '-'
                                ) {
                                    e.preventDefault()
                                }
                            }}
                        />
                        <span style={{ fontSize: 12, color: '#505A6B' }}>
                            км
                        </span>
                        <button
                            className={cls.clearButton}
                            onClick={handleInputRadiusClear}
                        >
                            ✕
                        </button>
                    </div>

                    {!isCity && (
                        <>
                            <div className={cls.divider} />
                            <div className={cls.toggleRow}>
                                <span className={cls.toggleLabel}>
                                    Куда угодно
                                </span>
                                <label
                                    className={`${cls.toggleWrapper} ${filtersArray.anywhereB ? [cls.on] : ''}`}
                                >
                                    <input
                                        name="anywhereB"
                                        type="checkbox"
                                        className={cls.toggle}
                                        checked={filtersArray.anywhereB}
                                        onChange={(e) =>
                                            handleCheckboxAnywhereChange(e)
                                        }
                                    />
                                    <span className={cls.toggleSlide} />
                                </label>
                            </div>

                            <div className={cls.toggleRow}>
                                <span className={cls.toggleLabel}>
                                    Искать обратку
                                </span>
                                <label
                                    className={`${cls.toggleWrapper} ${filtersArray.findReturn ? [cls.on] : ''}`}
                                >
                                    <input
                                        name="findReturn"
                                        type="checkbox"
                                        className={cls.toggle}
                                        checked={filtersArray.findReturn}
                                        onChange={(e) =>
                                            handleCheckboxFindReturnChange(e)
                                        }
                                    />
                                    <span className={cls.toggleSlide} />
                                </label>
                            </div>

                            <div className={cls.toggleRow}>
                                <span className={cls.toggleLabel}>Догруз</span>
                                <label
                                    className={`${cls.toggleWrapper} ${isReload ? [cls.on] : ''}`}
                                >
                                    <input
                                        name="orderTypes"
                                        type="checkbox"
                                        className={cls.toggle}
                                        checked={isReload}
                                        onChange={(e) =>
                                            handleCheckboxReloadChange(e)
                                        }
                                    />
                                    <span className={cls.toggleSlide} />
                                </label>
                            </div>
                        </>
                    )}
                </div>

                <div
                    className={cls.section}
                    style={{ animationDelay: `${0}s` }}
                >
                    <div className={cls.sectionTitle}>Дата погрузки</div>
                    <div className={cls.chips}>
                        {dates.map((date) => (
                            <button
                                key={date.type}
                                className={`${cls.chip} ${date.type === filtersArray.dateChoose ? [cls.active] : ''}`}
                                onClick={() =>
                                    handleDateCheckboxClick(date.type)
                                }
                            >
                                {date.text}
                            </button>
                        ))}
                    </div>
                </div>
            </div>

            <div className={cls.buttonsWrapper}>
                <div className={cls.buttons}>
                    <button
                        className={`${cls.button} ${cls.submitButton}`}
                        onClick={() => handleSubmit()}
                    >
                        🔍 Смотреть заявки
                    </button>
                    <button
                        className={`${cls.button} ${cls.resetButton}`}
                        onClick={() => handleReset()}
                    >
                        Сбросить фильтр
                    </button>
                </div>
            </div>
        </div>
    )
}

export default FilterPopupNew
